import styles from "@/shared/components/privacy/CookieConsentBanner.module.css";

type CookieConsentBannerProps = {
  isVisible: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onOpenSettings: () => void;
};

const CookieConsentBanner = ({
  isVisible,
  onAcceptAll,
  onRejectAll,
  onOpenSettings,
}: CookieConsentBannerProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <aside className={styles.banner} aria-label="Cookie consent banner">
      <div className={`card ${styles.shell}`}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>Privacy Choices</span>
          <p className={styles.text}>
            At ConfidaCare, we use cookies to keep the site secure, support patient and
            provider access, improve site performance, and personalize your experience.
            You can accept all cookies, reject optional cookies, or manage your
            preferences.
          </p>
        </div>
        <div className={styles.actions}>
          <button type="button" className="btn btn-primary btn-sm" onClick={onAcceptAll}>
            Accept All Cookies
          </button>
          <button type="button" className="btn btn-outline btn-sm" onClick={onRejectAll}>
            Reject All
          </button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onOpenSettings}>
            Cookie Settings
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CookieConsentBanner;
